export default "__VITE_ASSET__CmZJL0Us__"